import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ReferEarn.css";
import logo from "../assets/logo.png";
import spinWheelIcon from "../assets/spinandwin.png";
import referImage from "../assets/image.png";

/* ================= FLOATING SUPPORT BUTTONS COMPONENT ================= */
const FloatingSupportButtons = () => {
  const handleTelegramClick = () => {
    window.open("https://t.me/Instacoinxpayteam", "_blank");
  };

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+16417762676?text=Hello%20Instacoinxpay%2C%20I%20need%20assistance%20with%20the%20referral%20program%20on%20InstaCoinXPay.", "_blank");
  };

  return (
    <div className="refer-floating-support-buttons-unique">
      <button className="refer-float-btn-unique refer-telegram-float-unique" onClick={handleTelegramClick} aria-label="Telegram Support">
        <svg className="refer-float-icon-unique" viewBox="0 0 24 24" width="28" height="28" fill="white">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.06-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.35.5-.44-.01-1.3-.25-1.93-.46-.78-.26-1.4-.4-1.35-.84.03-.23.35-.47.96-.72 3.76-1.64 6.27-2.72 7.53-3.23 3.58-1.46 4.33-1.71 4.81-1.72.11 0 .35.02.51.16.13.11.17.26.19.4.01.06.02.19-.01.33z"/>
        </svg>
        <span className="refer-float-label-unique">Telegram Support</span>
      </button>
      
      <button className="refer-float-btn-unique refer-whatsapp-float-unique" onClick={handleWhatsAppClick} aria-label="WhatsApp Support">
        <svg className="refer-float-icon-unique" viewBox="0 0 24 24" width="28" height="28" fill="white">
          <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-5.46-4.45-9.91-9.91-9.91zm0 18.22c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.12.82.83-3.04-.2-.31c-.84-1.34-1.29-2.88-1.29-4.46 0-4.62 3.76-8.38 8.38-8.38 4.62 0 8.38 3.76 8.38 8.38 0 4.62-3.76 8.38-8.38 8.38zm4.59-6.27c-.25-.13-1.5-.74-1.73-.83-.23-.08-.4-.13-.57.13-.17.26-.65.83-.8 1-.14.17-.29.19-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.39-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.57-1.37-.78-1.88-.21-.5-.41-.44-.57-.45-.15-.01-.32-.01-.49-.01-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.11 0 1.24.91 2.45 1.04 2.61.13.17 1.79 2.73 4.33 3.83.61.26 1.08.42 1.45.54.61.19 1.16.16 1.6.1.49-.07 1.5-.61 1.71-1.2.21-.59.21-1.09.15-1.2-.07-.1-.23-.17-.48-.3z"/>
        </svg>
        <span className="refer-float-label-unique">WhatsApp Support</span>
      </button>
    </div>
  );
};

/* ================= SPIN WHEEL NAVIGATION BUTTON ================= */
const SpinWheelNavButton = ({ 
  position = "right",
  bottom = "180px",
  right = "30px",
  left = "auto",
  size = "60px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const navigate = useNavigate();
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #f7931a, #c8930a)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4)',
    zIndex: 9998,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    overflow: 'hidden',
    padding: '0px',
    ...positionStyles,
    ...style
  };

  React.useEffect(() => {
    if (!document.querySelector('#refer-spin-wheel-nav-keyframes-unique')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'refer-spin-wheel-nav-keyframes-unique';
      styleSheet.textContent = `
        @keyframes referSpinWheelNavPulse {
          0% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0.7); }
          70% { box-shadow: 0 8px 35px rgba(247, 147, 26, 0.7), 0 0 30px rgba(200, 147, 10, 0.6), 0 0 0 15px rgba(247, 147, 26, 0); }
          100% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0); }
        }
        @keyframes referSpinWheelNavGlow {
          0% { filter: drop-shadow(0 0 5px #f7931a); }
          50% { filter: drop-shadow(0 0 15px #c8930a); }
          100% { filter: drop-shadow(0 0 5px #f7931a); }
        }
        @keyframes referSpinWheelNavRotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .refer-spin-wheel-nav-float-unique {
          animation: ${pulseEffect ? 'referSpinWheelNavPulse 2s infinite, referSpinWheelNavGlow 3s infinite' : 'none'};
        }
        .refer-spin-wheel-nav-float-unique:hover {
          transform: scale(1.15) rotate(10deg) !important;
          background: radial-gradient(circle at 30% 30%, #ffd700, #f7931a) !important;
          box-shadow: 0 10px 40px rgba(247, 147, 26, 0.8), 0 0 35px rgba(255, 215, 0, 0.7) !important;
        }
        .refer-spin-wheel-nav-float-unique:hover .refer-wheel-icon-image-unique {
          transform: scale(1.2) rotate(15deg) !important;
        }
        .refer-wheel-icon-image-unique {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: transform 0.3s ease;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, [pulseEffect]);

  const handleClick = () => {
    navigate('/spinwheel');
  };

  return (
    <button
      onClick={handleClick}
      className={`refer-spin-wheel-nav-float-unique ${className}`}
      style={combinedStyles}
      aria-label="Go to Fortune Wheel"
      title="🎡 Spin & Win Rewards!"
    >
      <img 
        src={spinWheelIcon} 
        alt="Fortune Wheel"
        className="refer-wheel-icon-image-unique"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          transition: 'transform 0.3s ease',
          transform: 'scale(1.1)'
        }}
      />
      <div style={{
        position: 'absolute',
        inset: '-6px',
        borderRadius: '50%',
        border: '3px solid rgba(255, 215, 0, 0.5)',
        borderTopColor: '#f7931a',
        borderRightColor: '#ffd700',
        borderBottomColor: '#f7931a',
        borderLeftColor: '#ffd700',
        opacity: 0.9,
        animation: 'referSpinWheelNavRotate 4s linear infinite',
        pointerEvents: 'none',
        boxShadow: '0 0 15px rgba(247, 147, 26, 0.6)'
      }} />
      <div style={{
        position: 'absolute',
        inset: '2px',
        borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        opacity: 0.5,
        pointerEvents: 'none'
      }} />
    </button>
  );
};

const ReferEarn = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [shareMethod, setShareMethod] = useState("");

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";
    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };
  }, []);

  // Pass user email to Crisp when available
  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");
    const userName = localStorage.getItem("userName");
    
    if (userEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", userEmail]);
      if (userName) {
        window.$crisp.push(["set", "user:nickname", userName]);
      }
    }
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const referralCode = user?.referralCode || localStorage.getItem("userReferralCode");
  const referralUrl = user
    ? `${window.location.origin}/signup?referralCode=${user.referralCode}`
    : `${window.location.origin}/signup?referralCode=${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode || '');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = (platform) => {
    const text = `🚀 Join InstaCoinXPay and get 50 USDT (BEP20) welcome bonus! Use my referral code: ${referralCode}. Sign up here: ${referralUrl}`;
    
    setShareMethod(platform);
    
    switch(platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
        break;
      case 'telegram':
        window.open(`https://t.me/share/url?url=${encodeURIComponent(referralUrl)}&text=${encodeURIComponent(text)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=Join InstaCoinXPay & Get 50 USDT Bonus!&body=${encodeURIComponent(text)}`);
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralUrl)}&quote=${encodeURIComponent(text)}`, '_blank');
        break;
      case 'social':
        if (navigator.share) {
          navigator.share({
            title: 'Join InstaCoinXPay - Get 50 USDT Bonus!',
            text: text,
            url: referralUrl
          });
        }
        break;
      default:
        break;
    }
    
    setTimeout(() => setShareMethod(""), 2000);
  };

  return (
    <>
      <div className="refer-page-unique">
        <button className="refer-back-btn-unique" onClick={() => navigate("/dashboard")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="refer-card-unique">
          {/* LEFT IMAGE */}
          <div className="refer-left-unique">
            <img src={referImage} alt="Refer and Earn" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="refer-right-unique">
            {/* Top Banner */}
            <div className="refer-reward-banner-unique">
              <h4 className="refer-small-heading-unique">PER USER REFERRAL</h4>
              <div className="refer-big-amount-container-unique">
                <span className="refer-dollar-sign-unique">$</span>
                <h1 className="refer-big-amount-unique">50 USDT-BNB</h1>
              </div>
            </div>

            {/* Steps */}
            <div className="refer-steps-row-unique">
              <div className="refer-step-box-unique">
                <div className="refer-step-number-unique">1</div>
                <div className="refer-step-text-unique">
                  Share your<br />referral code
                </div>
              </div>
              <div className="refer-step-box-unique">
                <div className="refer-step-number-unique">2</div>
                <div className="refer-step-text-unique">
                  Friend signs-up<br />and verifies<br />account
                </div>
              </div>
              <div className="refer-step-box-unique">
                <div className="refer-step-number-unique">3</div>
                <div className="refer-step-text-unique">
                  Get 50 USDT-<br />BNB credited to<br />your wallet
                </div>
              </div>
            </div>

            {/* Referral Code */}
            <div className="refer-referral-container-unique">
              <p className="refer-referral-label-unique">Your personal referral code</p>
              <div className="refer-referral-box-unique">
                <div className="refer-code-box-unique">
                  <input
                    type="text"
                    value={referralCode || ""}
                    readOnly
                  />
                  <button onClick={handleCopy}>
                    {copied ? "Copied" : "Copy"}
                  </button>
                </div>
                <p className="refer-share-text-unique">
                  Share this code with friends. When they sign up using your code,
                  both of you get 50 USDT-BNB!
                </p>
              </div>
            </div>

            {/* Bonus Info */}
            <div className="refer-bonus-box-unique">
              <h4>🎁 Bonus Information</h4>
              <ul>
                <li>Every new user gets 50 USDT (BEP20) welcome bonus</li>
                <li>Referrer gets additional 50 USDT per successful referral</li>
                <li>No limit on number of referrals</li>
                <li>Bonuses are credited instantly after verification</li>
                <li>USDT can be traded, withdrawn, or used for payments</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Support Buttons - Telegram & WhatsApp */}
      <FloatingSupportButtons />
      
      {/* Spin Wheel Navigation Button */}
      <SpinWheelNavButton 
        position="right"
        bottom="180px"
        right="30px"
        pulseEffect={true}
        size="60px"
      />
    </>
  );
};

export default ReferEarn;